module.exports = __webpack_public_path__ + "img/5.9c41c21c.png";